import React from "react";
import { interpolate } from "../interpolate";
import { useCurrentFrame } from "../use-current-frame";
import { Freeze } from "./freeze";
// remapSpeed() is a helper function for the component <Slowed> that takes a frame number and a speed
const remapSpeed = ({
  frame,
  speed,
}) => {
  let framesPassed = 0;
  for (let i = 0; i <= frame; i++) {
    framesPassed += speed(i);
  }
 
  return framesPassed;
};
 
export const Slowed= ({ children }) => {
  const frame = useCurrentFrame();
  const remappedFrame = remapSpeed({
    frame,
    speed: (f) =>
      interpolate(f, [0, 20, 21], [1.5, 1.5, 0.5], {
        extrapolateRight: "clamp",
      }),
  });
  return <Freeze frame={remappedFrame}>{children}</Freeze>;
};